<template>
    <div>
        <div class="prescription-section">
            <div class="row">
                <div class="col-12 mb-4">
                    <div class="bg-white border-radius-5 p-4">
                        <div class="card-body bg-white border-radius-5 p-0 h-100">
                            <div class="row no-gutters justify-content-center align-items-center d-flex">
                                <div class="col-md-5 Add-Prescription pt-5 text-center">
                                    <h2>Add Prescription</h2>
                                    <p>Your medicine will show up here. Tap the button below to create your first medicine.</p>
                                    <form class="form-add mb-5">
                                        <div class="input-group mb-5">
                                            <input type="text" name="text" placeholder="Prescription Program  Name" />
                                        </div>
                                        <router-link class="btn btn-blue add-medicine" to="/mannual-prescription">Add Medicine</router-link>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "Add-prescription",
        data() {
            return {};
        },
        created(){
           this.pageName('Add Prescription')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/prescription/add-prescription.vue